module.exports = __webpack_public_path__ + "media/images/pages/trade-intro-df284c7a57752138a1b34a69f9e086a9.svg";